import {
  TABLE_CONSTANTS,
  useTableColumnsProspecto,
  EstadoProspectoEnum, useTableFilter, useTableServerSideFiltering,
  ROUTER_PATHS,
  texto,
  ModulosEnumChoice
} from "@/shared";
import { GeneralTable, useModalMotivoRechazo } from "@/shared/components/ui";
import { Grid, IconButton, Tooltip } from "@mui/material";
import PostAddIcon from '@mui/icons-material/PostAdd';
import { useNavigate } from "react-router-dom";
import CustomSearchFilterSupervisorVenta from "@/erp/sale/asesor/prospecto/componente/CustomSearchProspecto/CustomSearchFilterSupervisorVenta";
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import ModalMotivoRechazo from "@/shared/components/ui/ModalMotivoRechazo/ModalMotivoRechazo";
import { useGetProspectoPymes } from "@/shared/actions/erp/prospecto_pymes.action";
import { IProspectoPymes } from "@/shared/interfaces/erp/ventas_pymes/prospecto_pymes.interface";
interface TableProspectoPymesProps {
  estado_prospecto: EstadoProspectoEnum;
  enabled_actions: boolean
}

export default function TableProspectoPymes({
  estado_prospecto,
  enabled_actions
}: TableProspectoPymesProps) {


  const navigate = useNavigate();

  ///* hook

  const useHookModalMotivoRechazo = useModalMotivoRechazo({
    modulo: ModulosEnumChoice.PROSPECTO_PYMES
  })

  const {
    globalFilter,
    pagination,
    searchTerm,
    dateBefore,
    dateAfter,
    onChangeFilter,
    setPagination,
    onChangeRangeDate,
    cleanFilter,

    vendedor,
    setVendedor
  } = useTableFilter();

  const { columnsBase } = useTableColumnsProspecto({
    estado_prospecto: estado_prospecto
  });

  const {
    filterObject,
    columnFilters,
    setColumnFilters
  } = useTableServerSideFiltering();

  const { pageIndex, pageSize } = pagination;


  ///* react query
  const { isLoading, data: prospectoRes, isRefetching } =
    useGetProspectoPymes({
      es_pyme: true,
      page: pageIndex + 1,
      page_size: pageSize,
      identificacion: searchTerm,
      estado_prospecto: estado_prospecto,
      fecha_solicitud_before: dateBefore,
      fecha_solicitud_after: dateAfter,
      user_create: vendedor,
      ...filterObject,
      filterByState: false
    });


  return <>
    <Grid item xs={12}>
      <Grid item xs={12}>
        <CustomSearchFilterSupervisorVenta
          onChange={onChangeFilter}
          value={globalFilter}
          text="por Identificación"
          onChangeRangeDate={onChangeRangeDate}
          cleanFilter={cleanFilter}

          setVendedor={setVendedor}
        />
      </Grid>

      <GeneralTable<IProspectoPymes>
        columns={columnsBase}
        data={prospectoRes?.data.data || []}
        //
        isLoading={isLoading}
        isRefetching={isRefetching}
        ///* search
        enableGlobalFilter={false}
        enableSorting={false}
        // onGlobalFilterChange={setGlobalFilter}
        ///* pagination
        pagination={pagination}
        onPaging={setPagination}
        rowCount={prospectoRes?.data?.count}
        ///* filters - server side
        enableManualFiltering={true}
        columnFilters={columnFilters}
        onColumnFiltersChange={setColumnFilters}

        // crud
        canEdit={false}
        showCustomActionBtnSpace={enabled_actions}
        enableEditing={enabled_actions}
        actionsColumnSize={TABLE_CONSTANTS.ACTIONCOLUMN_WIDTH_MEDIUM}
        customActionBtnSpace={(value) => {
          return (
            <Grid container>
              <Grid item >
                <Tooltip title={'Preventa'} placement="top">
                  <IconButton
                    onClick={() => {
                      console.log(value);
                      
                      navigate(`${ROUTER_PATHS.ventasPymes.preventaCreateNav}/${value.id_prospecto_pymes}`);
                    }}
                  >
                    <PostAddIcon />
                  </IconButton>
                </Tooltip>
              </Grid>
              <Grid item>
                <Tooltip title={texto.cancelado} placement="top">
                  <IconButton
                    onClick={() => {
                      useHookModalMotivoRechazo.setDialogContentText(`Estás a punto de cancelar un Prospecto del cliente ${value.razon_social} con identificación ${value.identificacion}. ¿Estás seguro? Este cambio es irreversible.`)
                      useHookModalMotivoRechazo.setModalCancelar(true)
                      useHookModalMotivoRechazo.reset({
                        id: value.id_prospecto_pymes,
                        identificacion: value.identificacion,
                        razon_social: value.razon_social
                      })
                    }
                    }
                  >
                    <HighlightOffIcon color="error" />
                  </IconButton>
                </Tooltip>
              </Grid>


            </Grid>
          )
        }
        }

      />
    </Grid>

    <ModalMotivoRechazo
      {...useHookModalMotivoRechazo}
    />
  </>

}